<template>
  <div class="protol protol__active">
    <div class="head">
        <div class="head__fixed">
            <div class="head__fixed__box">
                <div class="header__fixed__left"><a href="javascript:history.go(-1)" class="back"></a></div>
                <div class="header__fixed__center"><h1>斐燃生活用户协议</h1></div>
                <div class="header__fixed__right"></div>
            </div>
        </div>
    </div>
      <div class="protol__box">
          <!-- <div class="protol__head">
              <div class="header__fixed__left"><a href="javascript:history.go(-1)" class="back"></a></div>
              <div class="tit">五星优服会员购卡开通协议</div>
          </div> -->
          <div class="protol__cont">
              <h1><b>斐燃生活用户协议</b></h1>
              <h3></h3>
              <p>生效日期：2020年5月18日</p>
              <p>尊敬的用户：</p>
              <p>感谢您注册使用“斐燃”产品，为让您更好地使用“斐燃”提供的产品和服务，请您仔细阅读以下条款，并确认您已完全理解《“斐燃”用户协议》（以下简称“用户协议”或“本协议”）之规定，尤其是免除及限制责任的条款、知识产权条款、法律适用及争议解决条款。</p>
              <p>若您对本声明或本协议任何条款有异议，请停止注册或使用“斐燃”所提供的全部服务。</p>
              <h3></h3>
              一、协议的接受、变更与补充
              <p>1、勾选本协议前选项框并点击“注册”，将视为您签署了本协议，表明您自愿接受本协议全部条款的约束，本协议将构成您与______________________公司及其经营的“斐燃”平台（以下统称“斐燃”，包括相关关联方）之间具有约束力的法律文件。无论您是进入“斐燃”浏览内容，还是在“斐燃”上发布任何内容，或者是直接或通过各类方式（如站外API引用等）间接使用“斐燃”服务和数据的行为，都将被视作已无条件接受本声明所涉全部内容。</p>
              </p><p>2、“斐燃”有权利对本协议进行修改，协议修改后，“斐燃”将通过在相关页面公告或发送通知等方式公布修改的内容，修改后的协议一经公布即有效的代替原协议。如果您不同意本协议的修改，请立即停止访问或使用本平台或取消已经获得的服务；如果您选择继续访问或使用本产品，则视为您已接受本协议的修改。
              </p><p>3、签署的本协议所列明的条款，并不能完全涵盖您与“斐燃”之间所有的权利和义务。因此，“斐燃”不定期公布的其他声明、规则等均视为本协议之补充协议，为本协议不可分割的组成部分，与本协议具有同等法律效力。
              </p><p>4、如本协议与“斐燃”平台其它协议条款不一致，以其它协议条款内容为准。</p>
              <h3></h3>
              <h3>二、帐号密码与注册、登录</h3>
              <p>1、帐号的取得
              </p><p>(1)您确认，在您开始注册“斐燃”前，已经具备中华人民共和国法律规定的与您行为相适应的民事行为能力。若您不具备前述与您行为相适应的民事行为能力，则您及您的监护人应依照法律规定承担因此而导致的一切后果。
              </p><p>(2)您注册成功后，即成为“斐燃”注册用户，用户须对在“斐燃”的注册信息的真实性、合法性、有效性承担全部责任。您可自行创建、修改昵称，但用户名和昵称的命名及使用应遵守相关法律法规并符合网络道德，不得冒充他人或恶意注册使人误认；不得利用他人的名义发布任何信息；不得恶意使用注册帐号导致其他用户误认；用户名和昵称中不能含有任何侮辱、诽谤、淫秽或暴力等侵害他人合法权益或违反公序良俗的词语。如您违反前述规定，“斐燃”有权随时限制或拒绝您使用该账号，甚至注销该账号。
              </p><p>(3)用户名的管理
              </p><p>1)请勿以党和国家领导人或其他名人的真实姓名、字、号、艺名、笔名、头衔等注册和使用昵称（如确为本人，需要提交相关证据并通过审核方可允许使用）；
              </p><p>2)请勿以国家组织机构或其他组织机构的名称等注册和使用昵称（如确为该机构，需要提交相关证据并通过审核方可允许使用）；
              </p><p>3)请勿注册和使用与其他网友相同、相仿的用户名或昵称；
              </p><p>4)请勿注册和使用不文明、不健康的用户名和昵称；
              </p><p>5)请勿注册和使用易产生歧义、引起他人误解或带有各种奇形怪状符号的用户名和昵称。
              </p><p>6)用户以虚假信息骗取账号名称注册，或账号头像、简介等注册信息存在违法和不良信息的，“斐燃”将暂停或注销。
              </p><p>2、请您妥善保管您注册时填写的用户帐号和密码，不要将帐号密码告知他人，因用户原因导致帐号或密码泄露而造成的法律后果由用户负责。同时，用户还应当对以此帐号登录进行的所有活动和事件承担全部后果与法律责任。
              </p><p>3、若您的帐号或密码遗失，可以通过注册信息按照相关步骤找回密码，若您发现账号遭到未授权的使用或存在其他安全漏洞的情况，应立即告知“斐燃”。</p>
              <h3></h3><h3>三、用户个人信息</h3>
              <p>1、个人信息的保护
              </p><p>(1)保护用户个人信息及个人隐私是“斐燃”的基本原则之一。
              </p><p>(2)您在注册帐号或使用“斐燃”服务的过程中，需要填写一些必要的信息。若国家法律法规有特殊规定的，您可能还需要填写真实的身份信息。若您填写的信息不完整，可能无法注册帐户，或在使用“斐燃”服务过程中受到限制。
              </p><p>(3)我们将尽一切可能采取适当的技术手段，保证您可以访问、更新和更正自己的注册信息或使用我们的服务时提供的其他个人信息，但出于安全性和身份识别（如找回密码服务）的考虑，您可能无法修改注册时提供的初始注册信息及其他验证信息。
              </p><p>(4)“斐燃”将运用各种安全技术和程序建立完善的管理制度来保护您的个人信息，以免遭受未经授权的访问、使用或披露。
              </p><p>(5)未经您的同意，“斐燃”不会向“斐燃”以外的任何公司、组织和个人披露您的个人信息，但法律法规另有规定的除外。
              </p><p>(6)“斐燃”非常重视对未成年人个人信息的保护，若未成年人（尤其是十岁以下）希望得以使用“斐燃”提供的服务，必须得到父母（监护人）的同意。
              </p><p>(7)“斐燃”将通过技术手段、强化内部管理等办法充分保护用户的个人隐私信息，保证不对外公开或向第三方披露或提供用户注册资料及用户在使用网络服务时存储在“斐燃”平台、服务器或数据库的非公开内容和信息，但下列情况除外：
              </p><p>1) 事先获得用户的授权；
              </p><p>2) 根据有关的法律法规要求；
              </p><p>3) 按照相关政府主管部门和司法机关的要求；
              </p><p>4) 为维护社会公众的利益；
              </p><p>5) 为维护“斐燃”的合法权益。
              </p><p>2、个人信息的收集
              </p><p>“斐燃”在提供服务时，可能会收集、储存和使用下列与您有关的信息。如果您不提供相关信息，可能无法注册成为我们的用户或无法享受我们提供的某些服务，或者无法达到相关服务拟达到的效果。
              </p><p>(1) 您提供的信息
              </p><p>1.	您在注册帐户或使用“斐燃”的服务时，向我们提供的相关个人信息，包括但不限于真实姓名、证件信息、电话号码、地址、电子邮件等；
              </p><p>2.	您通过“斐燃”的服务向其他方提供的共享信息，以及您使用我们的服务时所储存的信息。
              </p><p>(2)我们获取的您的信息
              </p><p>您使用“斐燃”服务时我们可能收集如下信息：使用“斐燃”服务时，系统可能通过cookies、web beacon或其他方式自动采集的技术信息，包括：
              </p><p>1) 设备或软件信息，包括但不限于您的移动设备、网页浏览器或用于接入我们服务的其他程序所提供的配置信息、您的IP地址、位置信息、设备存储和移动设备所用的版本和设备识别码；
              </p><p>2) 在使用我们服务时搜索或浏览的信息，包括但不限于您浏览过的文章、搜索的关键词，以及您在使用我们服务时浏览或要求提供的其他信息和内容详情；
              </p><p>3) 有关您曾使用的移动应用（APP）和其他软件的信息，以及您曾经使用该等移动应用和软件的信息。
              </p><p>3、个人信息的使用
              </p><p>(1)我们可能将在向您提供服务的过程之中所收集的信息用作下列用途：
              </p><p>1) 向您提供服务；
              </p><p>2) 在我们提供服务时，用于身份验证、客户服务、安全防范、诈骗监测、存档和备份用途，确保我们向您提供的产品和服务的安全性；
              </p><p>3) 帮助我们设计新服务，改善我们现有服务；
              </p><p>4) 使我们更加了解您如何接入和使用我们的服务，从而针对性地回应您的个性化需求，例如个性化的帮助服务和指示，或对您和其他用户作出其他方面的回应；
              </p><p>5) 软件认证或管理软件升级；
              </p><p>6) 让您参与有关我们产品和服务的调查。
              </p><p>(2)为了让您有更好的体验，也为了改善我们的服务，在符合相关法律法规的前提下，我们可能将通过某一项服务收集信息或向第三方提供用户的非个人隐私信息的方式，用于我们的其他服务。例如，在您使用我们的一项服务时所收集的信息，可能会用于向您提供特定内容，或向您展示与您相关的、非普遍推送的信息。
              </p><p>4、隐私政策
              </p><p>我们非常重视您的个人信息保护，依据最新的监管要求上线并更新了“斐燃”《隐私权保护政策》
              </p><p>该政策将帮助您了解以下内容：
              </p><p>1、 我们如何收集和使用您的个人信息
              </p><p>2、 我们如何使用 Cookie
              </p><p>3、 您的个人信息如何存储以及在全球范围转移
              </p><p>4、 我们如何共享、转让、公开披露您的个人信息
              </p><p>5、 我们如何保护您的个人信息
              </p><p>6、 您的权利
              </p><p>7、 未成年人条款
              </p><p>8、 本隐私政策时效及如何更新
              </p><p>9、 如何联系我们
              </p><p>10、其他
              </p><p>本隐私政策适用于“斐燃”的所有相关服务，请在使用我们的产品（或服务）前，仔细阅读并了解本《隐私权保护政策》，我们会适时对隐私政策进行修订，请以该协议为准。</p>
              <h3></h3><h3>四、“斐燃”的服务</h3>
              <p>1、“斐燃”的服务
              </p><p>(1)“斐燃”是一个信息分享及场地预订平台。“斐燃”向用户提供包括但不限于如下服务：文章、图片、视频、预订、分享；参与线上或线下活动；付费内容服务；电子商务服务等。“斐燃”有权对前述服务内容进行增减或调整。除非本协议另有其它明示规定，“斐燃”增加或强化目前本服务的任何新功能，包括所推出的新产品，均受本使用协议之规范。
              </p><p>(2)用户通过“斐燃”发表的信息为公开的信息，其他第三方均可以通过“斐燃”获取用户发表的信息，用户对任何信息的发表即认可该信息为公开的信息，并单独对此行为承担法律责任；任何用户均不应在“斐燃”上进行发表不愿被其他第三人获知的信息。
              </p><p>2、“斐燃”服务的使用
              </p><p>(1)您在使用本服务过程中，不得以任何方式利用“斐燃”直接或间接从事违反中国法律、以及社会公德的行为，应当遵守尊重不同地区、地域的道德和风俗习惯，并且应避免因使用本服务而使“斐燃”卷入政治和公共事件。
              </p><p>(2)“斐燃”有权对用户使用“斐燃”的情况进行审查和监督，如用户在使用“斐燃”时违反任何上述规定，“斐燃”或其授权的人有权要求用户改正或直接采取一切必要的措施（包括但不限于更改或删除用户发布的内容、暂停或终止用户使用“斐燃”的权利）以减轻用户不当行为造成的影响。
              </p><p>3、具体权限的开通
              </p><p>用户开通“斐燃”平台具体功能或权限时，“斐燃”可能将根据您登录帐号的具体情况以及届时的“斐燃”政策、规定，与您签订具体子协议，若您不同意子协议内容，可能无法使用相关服务或功能。
              </p><p>4、按现状提供服务
              </p><p>您理解并同意，“斐燃”的服务是按照现有技术和条件所能达到的现状提供的。“斐燃”会尽最大努力向您提供服务，确保服务的连贯性和安全性；但不能随时预见和防范法律、技术以及其他风险，包括但不限于不可抗力、病毒、木马、黑客攻击、系统不稳定、第三方服务瑕疵、政府行为等原因可能导致的服务中断、数据丢失以及其他的损失和风险。
              </p><p>5、设备
              </p><p>(1) 您应当理解，您使用“斐燃”的服务需自行准备与相关服务有关的终端设备（如手机、调制解调器等装置），并承担所需的费用（如电话费、上网费等费用）。
              </p><p>(2) 您理解并同意，您使用本服务时会耗用您的终端设备和带宽等资源。</p>
              <h3></h3><h3>五、知识产权声明</h3>
              <p>“斐燃”作为一个预订与分享平台，一直鼓励用户共享知识、传播文化，我们承诺将保护知识产权作为“斐燃”运营的基本原则之一。基于该项基本原则，您应当同意：
              </p><p>1.“斐燃”提供的网络服务中，包含的商标、标识、版面设计、排版方式、文本、图片、图形、动画、音频、视频等均受著作权法、商标法及其它法律保护，未经相关权利人（含“斐燃”及／或其他权利人）书面同意，任何人不得将上述内容在任何平台被直接或间接发布、使用、出于发布或使用目的的改写或再发布，或被用于其他任何商业目的。
              </p><p>2.“斐燃”平台内的所有产品、技术及全部程序，其知识产权均归属“斐燃”所有，您的任何使用行为，均不视为“斐燃”向您作出了任何授权。您对“斐燃”平台之内容的合理使用行为，必须符合以下条件：
              </p><p>(1) 您不得基于商业目的使用“斐燃”平台的内容；
              </p><p>(2) 您不得对外宣称您对“斐燃”平台内容享有任何知识产权；
              </p><p>(3) 当您的合理使用行为涉及除您以外的其他主体时，您在使用时必须明确告知该等主体。
              </p><p>1.	如果任何第三方侵犯了您相关的权利，您同意授权“斐燃”或其指定的代理人代表“斐燃”自身或您对该第三方发出通知、警告、投诉、发起行政执法、诉讼程序，或谈判和解，并且您同意在“斐燃”认为必要的情况下参与共同维权。
              </p><p>2.	“斐燃”平台内各功能板块存在特殊规定，优先适用特殊规定。</p>
              <h3></h3><h3>六、违法行为</h3>
              <p>1、 您在使用本服务时须遵守法律法规，不得利用本服务从事违法违规行为，以及不得利用“斐燃”服务制作、上载、复制、发布、传播或者转载如下内容，包括但不限于：
              </p><p>(1) 反对宪法所确定的基本原则的；
              </p><p>(2) 危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；
              </p><p>(3) 损害国家荣誉和利益的；
              </p><p>(4) 煽动民族仇恨、民族歧视，破坏民族团结的；
              </p><p>(5) 破坏国家宗教政策，宣扬邪教和封建迷信的；
              </p><p>(6) 散布谣言，扰乱社会秩序，破坏社会稳定的；
              </p><p>(7) 散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；
              </p><p>(8) 侮辱或者诽谤他人，侵害他人合法权益的；
              </p><p>(9) 含有法律、行政法规禁止的其他内容的信息。
              </p><p>2、 如果您违反了本条约定，相关国家机关或机构可能会对您提起诉讼、罚款或采取其他制裁措施，并要求“斐燃”给予协助。造成“斐燃”或第三方损害的，您应依法予以赔偿，“斐燃”不承担任何责任。
              </p><p>3、 如果“斐燃”发现或收到他人举报您发布的信息违反本条约定，“斐燃”有权进行独立判断并采取技术手段予以删除、屏蔽或断开链接。同时，“斐燃”有权视用户的行为性质，采取包括但不限于暂停或终止服务，限制、冻结或终止账号使用，追究法律责任等措施。
              </p><p>4、 您违反本条约定，导致任何第三方损害的，您应当独立承担责任；“斐燃”因此遭受的损失，您也应当一并赔偿。
              </p><p>5、 违反本条约定，视为您的严重违约，“斐燃”可以中止对您的服务，解除双方间的服务协议和法律关系，且无需退还您所支付的费用（如有），视为您支付“斐燃”的违约金，如不足以弥补“斐燃”的损失的，“斐燃”还可通过其他法律途径向您追索。</p>
              <h3></h3><h3>七、投诉处理</h3>
              <p>1、 “斐燃”高度重视自由表达和正当权利的平衡，依照法律规定删除违法信息是“斐燃”平台的法定义务。
              </p><p>2、 “斐燃”受理平台内侵犯企业或个人合法权益的侵权举报，包括但不限于涉及个人隐私、造谣与诽谤、商业侵权。
              </p><p>(1) 涉及个人隐私：发布内容中直接涉及身份信息，如个人姓名、家庭住址、身份证号码、工作单位、私人电话等详细个人隐私；
              </p><p>(2) 造谣、诽谤：发布内容中指名道姓（包括自然人和企业）的直接谩骂、侮辱、虚构中伤、恶意诽谤等；
              </p><p>(3) 商业侵权：泄露企业商业机密及其他根据保密协议不能公开讨论的内容。
              </p><p>3、 如果个人或单位发现“斐燃”上存在侵犯自身合法权益的内容，请与“斐燃”取得联系（邮箱： feiranvip@unionfit.cn ）。为了保证问题能够及时有效地处理，请务必提交真实有效、完整清晰的材料，否则不予受理。请使用以下格式（包括各条款的序号）：
              </p><p>(1) 权利人对涉嫌侵权内容拥有商标权、著作权和/或其他依法可以行使权利的权属证明；如果举报人非权利人，请举报人提供代表企业进行举报的书面授权证明。
              </p><p>(2) 充分、明确地描述侵犯了权利人合法权益的内容，提供涉嫌侵权内容在“斐燃”上的具体页面地址，指明涉嫌侵权内容中的哪些内容侵犯了上述列明的权利人的合法权益；
              </p><p>(3) 权利人具体的联络信息，包括姓名、身份证或护照复印件（对自然人）、单位登记证明复印件（对单位）、通信地址、电话号码、传真和电子邮件；
              </p><p>(4) 在侵权举报中加入如下关于举报内容真实性的声明：
              </p><p>1) 我本人为所举报内容的合法权利人；
              </p><p>2) 我举报的发布在“斐燃”社区中的内容侵犯了本人相应的合法权益；
              </p><p>3) 如果本侵权举报内容不完全属实，本人将承担由此产生的一切法律责任。
              </p><p>4、 处理流程
              </p><p>(1) 您认同，“斐燃”对于投诉信息是否属于平台监督范围有权独立做出判断，并非所有申请“斐燃”都必须受理。“斐燃”受理的投诉，将在自收到举报邮件七个工作日内处理完毕并给出回复。处理期间，不提供任何电话、邮件及其他方式的查询服务。
              </p><p>(2) 此为“斐燃”社区唯一官方的侵权投诉渠道，暂不提供其他方式处理此业务。用户在“斐燃”中的商业行为引发的法律纠纷，由交易双方自行处理，与“斐燃”无关。</p>
              <h3></h3><h3>八、 不可抗力与免责</h3>
              <p>1、您理解并同意，在使用“斐燃”服务的过程中，可能会遇到不可抗力等风险因素，使“斐燃”提供的服务发生中断。不可抗力是指不能预见、不能克服并不能避免且对一方或双方造成重大影响的客观事件，包括但不限于自然灾害如洪水、地震、瘟疫流行和风暴等，以及社会事件如战争、动乱、政府行为等。出现上述情况时，“斐燃”将努力在第一时间与相关单位配合，及时进行修复，但是由此给您造成的损失，“斐燃”在法律允许的范围内免责。
              </p><p>2、在法律允许的范围内，“斐燃”对以下情形导致的服务中断或受阻不承担责任：
              </p><p>(1) 受到手机病毒、木马或其他恶意程序、黑客攻击的破坏；
              </p><p>(2) 用户或“斐燃”的手机软件、系统、硬件和通信线路出现故障；
              </p><p>(3) 用户操作不当；
              </p><p>(4) 用户通过非“斐燃”授权的方式使用“斐燃”服务；
              </p><p>(5) 其他“斐燃”无法控制或合理预见的情形。
              </p><p>3、您理解并同意，在使用“斐燃”服务的过程中，可能会遇到网络信息或其他用户行为带来的风险，“斐燃”不对非“斐燃”发布的任何信息的真实性、适用性、合法性承担责任，也不对因侵权行为给您造成的损害负责。这些风险包括但不限于：
              </p><p>(1) 来自他人匿名或冒名的含有威胁、诽谤、令人反感或非法内容的信息；
              </p><p>(2) 因使用本协议项下的服务，遭受他人误导、欺骗或其他导致或可能导致的任何心理、生理上的伤害以及经济上的损失；
              </p><p>(3) 其他因网络信息或用户行为引起的风险。
              </p><p>4、您理解并同意，“斐燃”提供的服务并非为某些特定目的（包括但不限于核设施、军事用途、医疗设施、交通通讯等重要领域）而设计，如果因为软件或服务的原因导致上述操作失败而带来的人员伤亡、财产损失和环境破坏等，“斐燃”不承担法律责任。
              </p><p>5、“斐燃”依据本协议约定获得处理违法违规内容的权利，该权利不构成“斐燃”的义务或承诺，“斐燃”不能保证及时发现违法行为或进行相应处理。
              </p><p>6、在任何情况下，您不应轻信借款、索要密码或其他涉及财产的网络信息。涉及财产操作的，请一定先核实对方身份，并请经常留意“斐燃”或其他部门发布的有关防范诈骗犯罪的提示。
              </p><p>7、用户在“斐燃”发表的内容仅表明其个人的立场和观点，并不代表“斐燃”的立场或观点。作为内容的发表者，用户需自行对所发表内容负责，因所发表内容引发的一切纠纷，由该内容的发表者承担全部法律及连带责任；作为读者，用户应当自行对所看到的文章等内容进行甄别，并承担依照该等内容操作所带来的一切后果。“斐燃”不承担任何法律及连带责任。</p>
              <h3></h3><h3>九、协议的生效与修改</h3>
              <p>1、 您进入“斐燃”并使用“斐燃”的服务即视为您已阅读本协议并接受本协议的约束。
              </p><p>2、 “斐燃”有权在必要时修改本协议条款，您可以在相关服务页面查阅最新版本的协议条款。
              </p><p>3、 本协议条款变更后，如果您继续使用“斐燃”提供的服务，即视为您已接受修改后的协议。如果您不接受修改后的协议，应当退出“斐燃”并停止使用“斐燃”提供的服务。</p>
              <h3></h3><h3>十、 服务的中止与终止</h3>
              <p>1、 “斐燃”可能会对提供的服务内容进行不定时的变更，也可能会中断、中止或终止服务。
              </p><p>2、 如发生下列任何一种情形，“斐燃”有权不经通知而中断或终止向您提供的服务：
              </p><p>(1) 根据法律规定您应提交真实信息，而您提供的个人资料不真实、或与注册时信息不一致又未能提供合理证明；
              </p><p>(2) 您涉嫌违反相关法律法规规定；
              </p><p>(3) 按照法律规定或主管部门的要求；
              </p><p>(4) 出于安全的原因或其他必要的情形；
              </p><p>(5) 本协议中明确约定的其他情形。</p>
              <h3></h3><h3>十一、 法律适用与争议解决</h3>
              <p>1、 本协议签订地为中华人民共和国上海市浦东新区。
              </p><p>2、 本协议的成立、生效、履行、解释及纠纷解决，适用中华人民共和国大陆地区法律（仅为本合同之目的，不包括香港、台湾、澳门地区）。
              </p><p>3、 若您和“斐燃”之间发生任何纠纷或争议，首先应友好协商解决；协商不成的，您同意将纠纷或争议提交本协议签订地人民法院管辖。
              </p><p>4、 本协议所有条款的标题仅为阅读方便，本身并无实际涵义，不能作为本协议涵义解释的依据。
              </p><p>5、 本协议条款无论因何种原因部分无效或不可执行，其余条款仍有效，对双方具有约束力。</p>
              <h3></h3><h3>十二、 其他</h3>
              <p>1、 “斐燃”将根据平台功能区分或其他需要制订其他子协议，如子协议约定与本协议不一致，优先适用子协议条款；子协议未涉及的事宜，仍以本协议为准。
              </p><p>2、 如果您对本协议或本服务有意见或建议，可与“斐燃”客服联系，我们会给予您必要的帮助。</p>





          </div>
      </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        
      }
    },
    created() {},
    mounted() {
      console.log(this.$store.state)
  
    },
    methods: {
      
    },
  }
</script>

<style lang="less" scoped="scoped">
  @vm_base: 1/750*100vw;
  .protol{
  	transition:all 0.5s;
  	display:none;
  	opacity:0;
  	position:fixed;
  	left:0;
  	top:0;
  	z-index:99;
  	width:100%;
  	height:100%;
  	background:#fff;
  	.protol__box{
  		width:100%;
  		height:100%;
  		display:flex;
  		flex-direction: column;
      padding-bottom: 120*@vm_base;
  	}
  	.protol__head{
  		width:100%;
  		height:88*@vm_base;
  		line-height:88*@vm_base;
  		border-bottom:1px solid #EAEAEA;
  		.back{
  			float:left;
  			width:88*@vm_base;
  			height:88*@vm_base;
  			background:url(../../assets/images/base/icon_close.png) center center no-repeat;
  			background-size:34*@vm_base auto;
  		}
  		.tit{
  			font-size:34*@vm_base;
  			font-weight:600;
  			color:rgba(51,51,51,1);
  			text-align:center;
  			overflow:hidden;
  		}
  	}
  	.protol__cont{
  		flex:1;
  		padding:30*@vm_base;
  		overflow:auto;
  		font-size:26*@vm_base;
  		font-weight:400;
  		color:rgba(102,102,102,1);
  		line-height:46*@vm_base;
  		h1{
  			font-size:40*@vm_base;
  			font-weight:500;
  			color:rgba(51,51,51,1);
  			line-height:48*@vm_base;
  		}
  		h3{
  			margin-top:20*@vm_base;
  			margin-bottom:15*@vm_base;
  			font-size:30*@vm_base;
  			font-weight:500;
  			color:rgba(51,51,51,1);
  			line-height:52*@vm_base;
  		}
  	}
  }
  .protol__active{
  	display:block;
  	opacity:1
  }
</style>



// WEBPACK FOOTER //
// src/components/protocol/protocol.vue